import React from 'react';
import { map } from 'lodash';

const cloudinaryLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto,fl_progressive';


export default class ListingImage extends React.PureComponent {
  constructor (props) {
    super(props);

    this.onError = this.onError.bind(this);
  }

  onError () {
    this.img.src = '/web-hosting/assets/images/listing-placeholder.svg?v=rb';
    this.img.srcset = '/web-hosting/assets/images/listing-placeholder.svg?v=rb';
  }

  render () {
    const {
      alt = '',
      sizes = '',
      widths = ['400', '800', '1200', '2400', '3600'],
      classname = '',
      ratio,
      additionalTransform = '',
      imgId = ''
    } = this.props;

    const fallbackSrc = `${cloudinaryLink}/w_400/${imgId}`;
    const srcSet = map(widths, (width) => {
      const height = (width / ratio).toFixed(0);
      return `${cloudinaryLink},w_${width}${ratio ? `,h_${height}` : ''}/${additionalTransform ? `${additionalTransform}/` : ''}${imgId} ${width}w`;
    });

    return (
      <img
        style={{ width: '100%' }}
        ref={img => { this.img = img; }}
        onError={this.onError}
        className={classname}
        alt={'listing image' || alt}
        src={fallbackSrc}
        srcSet={imgId ? srcSet.toString() : ''}
        sizes={sizes || '100vw'}
      />
    );
  }
}
